// Actions
export const SUPER_ADMIN_LICENSE_FETCH_SUCCESS = 'SUPER_ADMIN_LICENSE_FETCH_SUCCESS';
export const SUPER_ADMIN_LICENSE_FETCH_FAILED = 'SUPER_ADMIN_LICENSE_FETCH_FAILED';
export const SUPER_ADMIN_CONTINUE_LICENSE_SYNC = 'SUPER_ADMIN_CONTINUE_LICENSE_SYNC';
export const SUPER_ADMIN_DISMISS_LICENSE_SYNC = 'SUPER_ADMIN_DISMISS_LICENSE_SYNC';
export const SUPER_ADMIN_LICENSE_FETCH_RESUME = 'SUPER_ADMIN_LICENSE_FETCH_RESUME';
export const SUPER_ADMIN_BULK_ACTIONS = 'SUPER_ADMIN_BULK_ACTIONS';
export const SUPER_ADMIN_CREATE_LICENSE = 'SUPER_ADMIN_CREATE_LICENSE';

export const SUPER_ADMIN_SHOW_CREATION_ERR = 'SUPER_ADMIN_SHOW_CREATION_ERR';
export const SUPER_ADMIN_SHOW_CREATION_SUCCESS = 'SUPER_ADMIN_SHOW_CREATION_SUCCESS';
export const SUPER_ADMIN_SHOW_MANAGE_ERR = 'SUPER_ADMIN_SHOW_MANAGE_ERR';
export const SUPER_ADMIN_SHOW_MANAGE_SUCCESS = 'SUPER_ADMIN_SHOW_MANAGE_SUCCESS';
export const SUPER_ADMIN_HIDE_MODAL = 'SUPER_ADMIN_HIDE_MODAL';

export const SUPER_ADMIN_VERIFY_USERS_EMAILS = 'SUPER_ADMIN_VERIFY_USERS_EMAILS';
export const SUPER_ADMIN_VERIFY_USERS_SUCCESS = 'SUPER_ADMIN_VERIFY_USERS_SUCCESS';
export const SUPER_ADMIN_REQUEST_UN_PHANTOM_USERS = 'SUPER_ADMIN_REQUEST_UN_PHANTOM_USERS';
export const SUPER_ADMIN_UN_PHANTOM_USERS_SUCCESS = 'SUPER_ADMIN_UN_PHANTOM_USERS_SUCCESS';

// License Search (server-side, paginated — separate from the legacy full-sync flow above)
export const SUPER_ADMIN_SEARCH_LICENSES_SUCCESS = 'SUPER_ADMIN_SEARCH_LICENSES_SUCCESS';
export const SUPER_ADMIN_SEARCH_LICENSES_FAILURE = 'SUPER_ADMIN_SEARCH_LICENSES_FAILURE';
export const SUPER_ADMIN_CLEAR_LICENSE_SEARCH = 'SUPER_ADMIN_CLEAR_LICENSE_SEARCH';
// Which of the two license-page views (new search vs legacy full-sync) is showing, keyed by
// SuperAdmin tool name — in Redux (not page-local state) so the global header's keyword search
// box (a distinct UX concept from the new structured cost-center search) can react to it.
export const SUPER_ADMIN_SET_LICENSE_VIEW_MODE = 'SUPER_ADMIN_SET_LICENSE_VIEW_MODE';

// Live, debounced "does a cost center with this name already exist" check the Create/Manage
// License modal uses for its duplicate-name warning — a small, dedicated slice deliberately kept
// separate from the licenseSearch slice above: both would otherwise dispatch the same
// ADMIN_ELASTICSEARCH_COST_CENTERS_SEARCH action type and collide (the modal's own lookup query
// would clobber the actual search view's visible results, and vice versa, since that slice is a
// single shared slot, not scoped per caller).
export const SUPER_ADMIN_CHECK_COST_CENTER_NAME_SUCCESS =
  'SUPER_ADMIN_CHECK_COST_CENTER_NAME_SUCCESS';
export const SUPER_ADMIN_CHECK_COST_CENTER_NAME_FAILURE =
  'SUPER_ADMIN_CHECK_COST_CENTER_NAME_FAILURE';
export const SUPER_ADMIN_CHECK_COST_CENTER_NAME = 'SUPER_ADMIN_CHECK_COST_CENTER_NAME';

// Errors
export const SUPER_ADMIN_LICENSE_ERR = 'SUPER_ADMIN_LICENSE_ERR';

// Misc
export const CREATE_LICENSE = 'CREATE_LICENSE';
export const MANAGE_LICENSE = 'MANAGE_LICENSE';

export const SUPER_ADMIN_SET_SELECTED_USER_CCS = 'SUPER_ADMIN_SET_SELECTED_USER_CCS';

// Users Records
export const SUPER_ADMIN_SET_USERS = 'SUPER_ADMIN_SET_USERS';
export const SUPER_ADMIN_ADD_USERS = 'SUPER_ADMIN_ADD_USERS';
export const SUPER_ADMIN_CLEAR_USERS = 'SUPER_ADMIN_CLEAR_USERS';
export const SUPER_ADMIN_SEARCH_COMPLETE = 'SUPER_ADMIN_SEARCH_COMPLETE';

// Product Versions
export const SUPER_ADMIN_FETCH_PRODUCT_VERSIONS = 'SUPER_ADMIN_FETCH_PRODUCT_VERSIONS';
export const SUPER_ADMIN_PRODUCT_VERSIONS_FETCH_SUCCESS =
  'SUPER_ADMIN_PRODUCT_VERSIONS_FETCH_SUCCESS';
export const SUPER_ADMIN_UPDATE_PRODUCT_WHITELIST = 'SUPER_ADMIN_UPDATE_PRODUCT_WHITELIST';
export const SUPER_ADMIN_UPDATE_PRODUCT_WHITELIST_SUCCESS =
  'SUPER_ADMIN_UPDATE_PRODUCT_WHITELIST_SUCCESS';
export const SUPER_ADMIN_CREATE_PRODUCT_VERSION = 'SUPER_ADMIN_CREATE_PRODUCT_VERSION';
export const SUPER_ADMIN_CREATE_PRODUCT_VERSION_SUCCESS =
  'SUPER_ADMIN_CREATE_PRODUCT_VERSION_SUCCESS';
export const SUPER_ADMIN_UPDATE_PRODUCT_ASSETS = 'SUPER_ADMIN_UPDATE_PRODUCT_ASSETS';
export const SUPER_ADMIN_UPDATE_PRODUCT_ASSETS_SUCCESS =
  'SUPER_ADMIN_UPDATE_PRODUCT_ASSETS_SUCCESS';
export const SUPER_ADMIN_UPDATE_PRODUCT_IS_ACTIVE = 'SUPER_ADMIN_UPDATE_PRODUCT_IS_ACTIVE';
export const SUPER_ADMIN_UPDATE_PRODUCT_IS_ACTIVE_SUCCESS =
  'SUPER_ADMIN_UPDATE_PRODUCT_IS_ACTIVE_SUCCESS';

// Product Features
export const SUPER_ADMIN_FETCH_PRODUCT_FEATURES = 'SUPER_ADMIN_FETCH_PRODUCT_FEATURES';
export const SUPER_ADMIN_PRODUCT_FEATURES_FETCH_SUCCESS =
  'SUPER_ADMIN_PRODUCT_FEATURES_FETCH_SUCCESS';
export const SUPER_ADMIN_FETCH_SEAT_FEATURES = 'SUPER_ADMIN_FETCH_SEAT_FEATURES';
export const SUPER_ADMIN_SEAT_FEATURES_FETCH_SUCCESS = 'SUPER_ADMIN_SEAT_FEATURES_FETCH_SUCCESS';
export const SUPER_ADMIN_SET_SEAT_FEATURE = 'SUPER_ADMIN_SET_SEAT_FEATURE';

// Archive Active EOT
export const SUPER_ADMIN_FETCH_ACTIVE_EOT = 'SUPER_ADMIN_FETCH_ACTIVE_EOT';
export const SUPER_ADMIN_FETCH_ACTIVE_EOT_SUCCESS = 'SUPER_ADMIN_FETCH_ACTIVE_EOT_SUCCESS';
export const SUPER_ADMIN_FETCH_ACTIVE_EOT_ERROR = 'SUPER_ADMIN_FETCH_ACTIVE_EOT_ERROR';
export const SUPER_ADMIN_ARCHIVE_ACTIVE_EOT = 'SUPER_ADMIN_ARCHIVE_ACTIVE_EOT';
export const SUPER_ADMIN_ARCHIVE_ACTIVE_EOT_SUCCESS = 'SUPER_ADMIN_ARCHIVE_ACTIVE_EOT_SUCCESS';
export const SUPER_ADMIN_ARCHIVE_ACTIVE_EOT_ERROR = 'SUPER_ADMIN_ARCHIVE_ACTIVE_EOT_ERROR';
export const SUPER_ADMIN_ARCHIVE_ACTIVE_EOT_RESET = 'SUPER_ADMIN_ARCHIVE_ACTIVE_EOT_RESET';

// User Field Updates
export const SUPER_ADMIN_UPDATE_USER_FIELD = 'SUPER_ADMIN_UPDATE_USER_FIELD';
export const SUPER_ADMIN_UPDATE_USER_FIELD_SUCCESS = 'SUPER_ADMIN_UPDATE_USER_FIELD_SUCCESS';
export const SUPER_ADMIN_UPDATE_USER_FIELD_ERROR = 'SUPER_ADMIN_UPDATE_USER_FIELD_ERROR';
export const SUPER_ADMIN_SET_USER_PHANTOM = 'SUPER_ADMIN_SET_USER_PHANTOM';
export const SUPER_ADMIN_SET_USER_PHANTOM_SUCCESS = 'SUPER_ADMIN_SET_USER_PHANTOM_SUCCESS';
export const SUPER_ADMIN_SET_USER_PHANTOM_ERROR = 'SUPER_ADMIN_SET_USER_PHANTOM_ERROR';
export const SUPER_ADMIN_SET_USER_EMAIL_VERIFIED = 'SUPER_ADMIN_SET_USER_EMAIL_VERIFIED';
export const SUPER_ADMIN_SET_USER_EMAIL_VERIFIED_SUCCESS =
  'SUPER_ADMIN_SET_USER_EMAIL_VERIFIED_SUCCESS';
export const SUPER_ADMIN_SET_USER_EMAIL_VERIFIED_ERROR =
  'SUPER_ADMIN_SET_USER_EMAIL_VERIFIED_ERROR';
// TODO: password reset is deferred until a restricted admin role is available
// export const SUPER_ADMIN_SET_USER_PASSWORD = 'SUPER_ADMIN_SET_USER_PASSWORD';
// export const SUPER_ADMIN_SET_USER_PASSWORD_SUCCESS = 'SUPER_ADMIN_SET_USER_PASSWORD_SUCCESS';
